import React, { useCallback } from "react";
import { registerInformationAction } from "../../../state/usecase/information/actions";
import { InformationTitle } from "../../../domain/information/InformationTitle";
import { InformationContent } from "../../../domain/information/InformationContent";
import { InputTextBox } from "../common/input/InputTextBox";
import { Button } from "../common/button/Button";
import { Paths } from "../../../Paths";
import { BackButton } from "../common/button/BackButton";
import { InputTextArea } from "../common/input/InputTexArea";
import { useAppDispatch } from "../../../state/store";
import { useInput } from "../../hooks/common/useInput";
import { unwrapResult } from "@reduxjs/toolkit";
import { RegisterInformationSuccessResponseType } from "../../../state/usecase/information/api";
import { useNavigate } from "react-router-dom";

export function InformationAddPage() {
    const [informationTitle, , handleInformationTitleChanged] = useInput("");

    const [informationContent, , handleInformationContentChanged] = useInput("");

    const dispatch = useAppDispatch();

    const navigate = useNavigate();

    const handleUserInformationRegisterClicked = useCallback(() => {
        const invalidMessage: string[] = [];
        // タイトルの長さチェック
        if (InformationTitle.isInvalidSize(informationTitle)) {
            invalidMessage.push(InformationTitle.messageInvalidSize("タイトル"));
        }
        // 内容の長さチェック
        if (InformationContent.isInvalidSize(informationContent)) {
            invalidMessage.push(InformationContent.messageInvalidSize("お知らせ内容"));
        }

        if (invalidMessage.length) {
            alert(invalidMessage.join("\n"));
            return;
        }

        dispatch(
            registerInformationAction({
                requestData: {
                    title: InformationTitle.fromString(informationTitle),
                    content: InformationContent.fromString(informationContent)
                }
            })
        )
            .then(unwrapResult)
            .then((res: { information: RegisterInformationSuccessResponseType }) => {
                navigate(`${Paths.information}/${res.information.id}`, { replace: true });
            });
    }, [dispatch, navigate, informationContent, informationTitle]);

    return (
        <div className={"information_add_page"}>
            <div className={"container"}>
                <BackButton />
                <p className={"header"}>お知らせの追加</p>
                <div className={"information_edit"}>
                    <div className={"content"}>
                        <div className={"body"}>
                            <div className="label">タイトル</div>
                            <InputTextBox value={informationTitle} handleTextChanged={handleInformationTitleChanged} />
                        </div>
                        <div className={"body"}>
                            <div className="label">内容</div>
                            <InputTextArea value={informationContent} handleTextChanged={handleInformationContentChanged} />
                        </div>
                    </div>
                    <Button label={"登録"} onClick={handleUserInformationRegisterClicked} />
                </div>
            </div>
        </div>
    );
}
